import Vue from 'vue';
import Router from 'vue-router';
import store from './store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "Home" */ './views/Home.vue'),
    }, {
      path: '/deals',
      name: 'deals',
      component: () => import(/* webpackChunkName: "Deals" */ './views/Deals.vue'),
      meta: {
        requiresAuth: true,
      },
    }, {
      path: '/auth/callback/:connection',
      name: 'auth-cb',
      component: () => import(/* webpackChunkName: "AuthCallback" */ './views/AuthCallback.vue'),
    }, {
      path: '/edit/deal',
      name: 'edit-deal',
      component: () => import(/* webpackChunkName: "EditDeal" */ './views/EditDeal.vue'),
      meta: {
        requiresAuth: true,
      },
    }, {
      path: '/my-events',
      name: 'my-events',
      component: () => import(/* webpackChunkName: "MyEvents" */ './views/MyEvents.vue'),
      meta: {
        requiresAuth: true,
      },
    }, {
      path: '/event/:eventId',
      name: 'event',
      component: () => import(/* webpackChunkName: "Event" */ './views/Event.vue'),
      children: [{
        path: 'view',
        alias: '/',
        name: 'event-view',
        component: () => import(/* webpackChunkName: "EventView" */ './components/event/view/EventView.vue'),
      }, {
        path: 'edit',
        name: 'event-edit',
        component: () => import(/* webpackChunkName: "EventEdit" */ './components/event/edit/EventEdit.vue'),
        meta: {
          requiresAuth: true,
        },
        children: [{
          name: 'event-overview',
          path: 'overview',
          alias: '/',
          component: () => import(/* webpackChunkName: "EventOverview" */ './components/event/edit/EventOverview.vue'),
        }, {
          name: 'event-pitch',
          path: 'pitch',
          component: () => import(/* webpackChunkName: "EventPitch" */ './components/event/edit/EventPitch.vue'),
        }, {
          name: 'event-pricing',
          path: 'pricing',
          component: () => import(/* webpackChunkName: "EventPricing" */ './components/event/edit/EventPricing.vue'),
        }, {
          name: 'event-market-trend',
          path: 'market',
          component: () => import(/* webpackChunkName: "EventMarketTrend" */ './components/event/edit/EventMarketTrend.vue'),
        }, {
          name: 'event-team',
          path: 'team/:token?',
          component: () => import(/* webpackChunkName: "EventTeam" */ './components/event/edit/EventTeam.vue'),
        }, {
          name: 'event-preview',
          path: 'preview',
          component: () => import(/* webpackChunkName: "EventPreview" */ './components/event/edit/EventPreview.vue'),
        }],
      }],
    }, {
      path: '/privacy',
      name: 'privacy',
      component: () => import(/* webpackChunkName: "Privacy" */ './views/Privacy.vue'),
    }, {
      path: '/cookies',
      name: 'cookies',
      component: () => import(/* webpackChunkName: "Cookie" */ './views/Cookie.vue'),
    }, {
      path: '/terms',
      name: 'terms',
      component: () => import(/* webpackChunkName: "Terms" */ './views/Terms.vue'),
    }, {
      path: '/admin',
      name: 'admin',
      component: () => import(/* webpackChunkName: "Admin" */ './views/Admin.vue'),
      children: [{
        name: 'admin-events',
        path: 'events',
        alias: '/',
        component: () => import(/* webpackChunkName: "EventOverview" */ './components/admin/AdminEvents.vue'),
      }, {
        name: 'admin-users',
        path: 'users',
        component: () => import(/* webpackChunkName: "EventOverview" */ './components/admin/AdminUsers.vue'),
      }],
    }, {
      path: '/user/:userName',
      name: 'user-profile',
      component: () => import(/* webpackChunkName: "UserProfile" */ './views/UserProfile.vue'),
      children: [{
        name: 'user-profile-events',
        path: 'events',
        alias: '/',
        component: () => import(/* webpackChunkName: "UserProfileEvents" */ './components/user-profile/UserProfileEvents.vue'),
      // }, {
      //   name: 'user-profile-deals',
      //   path: 'deals',
      //   component: () => import(/* webpackChunkName:
      // "UserProfileDeals" */ './components/user-profile/UserProfileDeals.vue'),
      // }, {
      //   name: 'user-profile-reviews',
      //   path: 'reviews',
      //   component: () => import(/* webpackChunkName:
      // "UserProfileReviews" */ './components/user-profile/UserProfileReviews.vue'),
      }],
    }, {
      path: '/account',
      name: 'account',
      component: () => import(/* webpackChunkName: "Account" */ './views/Account.vue'),
      meta: {
        requiresAuth: true,
      },
      children: [{
        name: 'account-edit',
        path: 'edit',
        alias: '/',
        component: () => import(/* webpackChunkName: "EditProfile" */ './components/account/EditProfile.vue'),
      }, {
        name: 'account-password',
        path: 'password',
        component: () => import(/* webpackChunkName: "ChangePassword" */ './components/account/ChangePassword.vue'),
      }, {
        name: 'account-social',
        path: 'social',
        component: () => import(/* webpackChunkName: "SocialVerification" */ './components/account/SocialVerification.vue'),
      }, {
        name: 'account-settings',
        path: 'settings',
        component: () => import(/* webpackChunkName: "AccountSettings" */ './components/account/AccountSettings.vue'),
      }],
    }, {
      path: '/password/forgot',
      component: () => import(/* webpackChunkName: "PasswordForgot" */ './views/PasswordForgot.vue'),
    }, {
      path: '/password/reset/:username/:token',
      component: () => import(/* webpackChunkName: "PasswordReset" */ './views/PasswordReset.vue'),
    }, {
      path: '/404',
      name: 'page-not-found',
      component: () => import(/* webpackChunkName: "PageNotFound" */ './views/PageNotFound.vue'),
    }, {
      path: '*',
      redirect: '/404',
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth) {
    const isAuthenticated = await store.dispatch('auth/authenticate');
    if (isAuthenticated) {
      next();
    }
  } else {
    next();
  }
});

export default router;
